import { useRootStore } from './rootStore'

export function useRouter() {
  return useRootStore().router
}

export function useQueryParams() {
  return useRouter().queryParams
}
